import { isExpiredToken } from '@utils/index';
import {
  ACCESS_TOKEN_KEY,
  REFESH_TOKEN_KEY,
  getCookie,
  getRefreshToken,
  removeCookie,
  setCookie,
} from '../storage/cookies';

import authApi from '../api/auth';

export const isExpiredAuth = async () => {
  const auth = getCookie(ACCESS_TOKEN_KEY) || '{}';
  const authJson = JSON.parse(auth);
  if (isExpiredToken(authJson.access)) {
    removeCookie(ACCESS_TOKEN_KEY);
    return true;
  }
  // const { error, data } = await getAccessToken(authJson.refresh_token || '', authJson.email);
  // if (error) {
  //   return true;
  // }
  return false;
};

async function getAccessToken(refreshToken: string, email: string) {
  if (!refreshToken) {
    return {
      error: true,
      data: null,
    };
  }
  try {
    const data = await authApi.refreshAccessToken(email, refreshToken);
    if (data) {
      setCookie(ACCESS_TOKEN_KEY, { access: data.access_token });
      setCookie(REFESH_TOKEN_KEY, { access: data.refresh_token });
    }
    return {
      error: false,
      data,
    };
  } catch (error) {
    return {
      error: true,
      data: null,
    };
  }
}

export async function refreshAccessToken() {
  const auth = getRefreshToken();
  const authJson = JSON.parse(auth);
  const { error } = await getAccessToken(authJson.refresh_token || '', authJson.email);
  if (error) {
    return false;
  }
  return true;
}
